/* eslint-disable @reatom/unit-naming-rule */

import { reaction } from '@reatom/framework'

import { isLoggedInAtom } from '@root/entities/auth'
import { reatomResource } from '@root/shared/lib'

import { fetchFeeConfigRequestAction } from './fee-config-requests'

export const reatomFeeConfigAtom = reatomResource(
  async (ctx) => {
    const result = await ctx.schedule(() => fetchFeeConfigRequestAction(ctx))
    return result
  },
  {
    name: 'reatomFeeConfigAtom',
    retry: {
      enabled: true,
    },
  },
)

export const initializeFeeConfigAction = reaction(async (ctx) => {
  const isLoggedIn = ctx.spy(isLoggedInAtom)
  if (isLoggedIn) {
    reatomFeeConfigAtom.run(ctx)
  }
})
